const createErrorResponse = (error: Error) => ({ data: null, error, loading: false }) as const;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const createDataResponse = (data: any) => ({ data, error: null, loading: false }) as const;

export { createDataResponse, createErrorResponse };
